export default __webpack_public_path__ + "img/scmmain1.e720fc97.png";